export const firstFewCountries = [
  { tabType: 'ALL', title: 'lang058' },
  { tabType: 'US', title: 'lang076' },
  { tabType: 'VN', title: 'lang062' },
  { tabType: 'ID', title: 'lang060' },
  { tabType: 'BR', title: 'lang080' },
  { tabType: 'SA', title: 'lang064' }
];

export const moreCountries = [
  { tabType: 'JP', title: 'lang081' },
  { tabType: 'TR', title: 'lang079' },
  { tabType: 'RU', title: 'lang074' },
  { tabType: 'TH', title: 'lang063' },
  { tabType: 'GB', title: 'lang227' },
  { tabType: 'DE', title: 'lang226' },
  { tabType: 'IN', title: 'lang061' },
  { tabType: 'MY', title: 'lang065' },
  { tabType: 'IT', title: 'lang233' },
  { tabType: 'PH', title: 'lang066' },
  { tabType: 'KH', title: 'lang067' },
  { tabType: 'SG', title: 'lang068' },
  { tabType: 'IQ', title: 'lang069' },
  { tabType: 'TW', title: 'lang070' },
  { tabType: 'KR', title: 'lang071' },
  { tabType: 'KW', title: 'lang072' },
  { tabType: 'LA', title: 'lang073' },
  { tabType: 'CN', title: 'lang075' },
  { tabType: 'BD', title: 'lang077' },
  { tabType: 'QA', title: 'lang078' },
  { tabType: 'MA', title: 'lang082' },
  { tabType: 'PK', title: 'lang083' },
  { tabType: 'HK', title: 'lang084' },
  { tabType: 'AE', title: 'lang085' },
  { tabType: 'JO', title: 'lang086' },
  { tabType: 'CA', title: 'lang087' },
  { tabType: 'AU', title: 'lang088' },
  { tabType: 'EG', title: 'lang089' },
  { tabType: 'KZ', title: 'lang190' },
  { tabType: 'OM', title: 'lang191' },
  { tabType: 'NP', title: 'lang192' },
  { tabType: 'BN', title: 'lang193' }
];
